import { Link } from "react-router-dom";
import { Button, Card } from "../components";

export default function NotFound() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        padding: "2rem",
      }}
    >
      <Card>
        <h2 style={{ margin: "0 0 0.5rem" }}>404 — Page Not Found</h2>
        <p style={{ color: "var(--c-text-muted)", margin: "0 0 1rem" }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/fleet">
          <Button>Back to Dashboard</Button>
        </Link>
      </Card>
    </div>
  );
}
